import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const SizeConfigs = {
  List: lazyNamed(() => import('./containers/SizeConfigsList/index.tsx'), 'SizeConfigsList'),
};
